<template>
    <div class="paper-card flex flex-col gap-4 rounded border border-solid border-grey-40 bg-white px-6 py-4">

        <div class="flex items-center gap-4">

            <span class="shrink-0 text-xl font-semibold text-black">
                {{ title }}
            </span>

            <div class="th-tooltip" :data-tip="t('literatureTrendTip')">
                <PtIcon icon="SolidInfo" class="fill-grey-55 text-2xl" />
            </div>

            <i class="grow"></i>

            <button @click="downloadChartAsImage" :disabled="disableUI" class="th-btn th-btn-plain shrink-0">
                <PtIcon class="th-btn-icon fill-grey-450 text-2xl" icon="SolidExport" />
                <span>{{ t('download') }} </span>
            </button>

        </div>

        <div class="h-[348px]">

            <BIChart ref="paperTrendChart"
                     :chartKey="chartKey"
                     :isLoading="isFetchLoading"
                     :configTaskFunc="chartConfig"
                     :dataTaskFunc="getPaperTrendChartData"
                     @click="handleDrillDown"
                     class="h-full w-full" />

        </div>
    </div>
</template>

<script setup lang="ts">
import { PtIcon } from 'patsnap-biz';
import '@patsnap-ui/icon/assets/solid/export.svg';
import '@patsnap-ui/icon/assets/VectorGradient.svg';
import BIChart from '@/components/BIChart.vue';
import { usePaperTrend } from '@/composables/use-paper-trend';
import { ref } from 'vue';
import { useI18n } from 'vue-i18n';

const { t } = useI18n()

const paperTrendChart = ref<{
    generateChartImage: () => Promise<string>,
    drawChart: () => void,
    isChartLoaded: () => boolean
    isEmptyChart: boolean
}>();

const {
    disableUI,
    chartKey,
    chartConfig,
    isFetchLoading,
    getPaperTrendChartData,
    downloadChartAsImage,
    handleDrillDown,
    title,
} = usePaperTrend(paperTrendChart);

</script>

<style lang="scss">
.paper-card-tips {
    background: linear-gradient(95deg, rgba(219, 234, 255, 0.30) 6.07%, rgba(228, 231, 255, 0.30) 100%);
}
</style>
